/* 引入资源请求插件*/
import axios from 'axios'

axios.defaults.timeout = 30000 // 响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8' // 配置请求头
axios.defaults.withCredentials = true
axios.defaults.baseURL = window.SITE_CONFIG['baseUrl'] // 配置接口地址

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      // debugger
      if (response.data && response.data.result) {
        const SM4 = require('gm-crypt').sm4
        const sm4Config = {
          key: 'JeF8U9wHFOMfs2S3',
          mode: 'ecb',
          cipherType: 'bsse64'
        }
        const sm4 = new SM4(sm4Config)
        sm4.encrypt()
        response.data.result = JSON.parse(sm4.decrypt(response.data.result))
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    throw error
    // if (error.response) {
    //   return Promise.reject(error.response)
    // }
  })
// 加密
axios.encrypt = (obj) => {
  const SM4 = require('gm-crypt').sm4
  const sm4Config = {
    key: 'JeF8U9wHFOMfs2S3',
    mode: 'ecb',
    cipherType: 'bsse64'
  }
  const sm4 = new SM4(sm4Config)
  return sm4.encrypt(JSON.stringify(obj))
}

export default axios
